var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSteel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 255.1 255.1",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0Steel{fill:#5a8ea2}.st1Steel{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 127.6,
    r: 121.6,
    className: "st0Steel"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.336,127.584c-0.022-0.038-0.022-0.085,0-0.123l41.883-71.558c0.022-0.037,0.062-0.059,0.104-0.059h83.013 c0.044,0,0.083,0.022,0.106,0.061l41.423,71.558c0.021,0.037,0.021,0.085,0,0.122l-41.423,71.479 c-0.022,0.037-0.062,0.061-0.106,0.061H86.323c-0.044,0-0.083-0.022-0.104-0.059L44.336,127.584z M166.187,127.482 c0,21.304-17.27,38.574-38.574,38.574s-38.574-17.27-38.574-38.574s17.27-38.574,38.574-38.574S166.187,106.178,166.187,127.482z",
    className: "st1Steel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteel);
export default __webpack_public_path__ + "static/media/steel.aa004a6b73a288e9128a06dd7ce187a6.svg";
export { ForwardRef as ReactComponent };